import { useAuth } from '../../context/AuthContext';

const SessionTimer = () => {
  const { sessionTimeout } = useAuth();

  if (!sessionTimeout) {
    return null;
  }

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="session-timer">
      Session expires in: {formatTime(sessionTimeout)}
    </div>
  );
};

export default SessionTimer;
